export default "__VITE_ASSET__A5nRWaPg__"